<div class="col-md-6 offset-md-3 mt-4 mt-md-5 change-password-container">
	<div class="ng-container change-password-logo">
		<img src="splashscreen_logo.png">
	</div>
	<div class="card">
		<h5 class="card-header">Premises by Billdeo - Reset Password</h5>
		<div class="card-body">
			<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
				<div class="form-group">
					<label class="sr-only" for="password">Password</label>
					<div class="input-group mb-2">
						<div class="input-group-prepend">
							<div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
						</div>
						<input type="password" formControlName="password" class="form-control py-0" name="password" id="password" placeholder="New Password" [pattern]="passwordPattern" [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
						@if (submitted && f['password'].errors) {
							<div class="invalid-feedback">
								@if (f['password'].errors['required']) {
									<div>Password is required</div>
								}
							</div>
						}
						@if (f['password'] && f['password'].errors?.['pattern']) {
							<div class="invalid-feedback">
								Password has to be 5 or more characters.
							</div>
						}
					</div>
				</div>

				<div class="form-group">
					<label class="sr-only" for="confirmPassword">Confirm Password</label>
					<div class="input-group mb-2">
						<div class="input-group-prepend">
							<div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
						</div>
						<input type="password" formControlName="confirmPassword" class="form-control py-0" name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" [pattern]="passwordPattern" [ngClass]="{ 'is-invalid': submitted && (f['confirmPassword'].errors || resetPasswordForm.hasError('mustMatch')) }">
						@if (submitted && f['confirmPassword'].errors) {
							<div class="invalid-feedback">
								@if (f['confirmPassword'].errors['required']) {
									<div>Please confirm password</div>
								}
							</div>
						}
						@if (f['confirmPassword'] && f['confirmPassword'].errors?.['pattern']) {
							<div class="invalid-feedback">
								Confirm Password has to be 5 or more characters.
							</div>
						}
						@if (submitted && f['confirmPassword'].errors?.['mustMatch']) {
							<div class="invalid-feedback">
								Passwords do not match
							</div>
						}
					</div>
				</div>

				@if (error) {
					<div class="alert alert-danger mt-2">{{ error }}</div>
				}

				<div class="change-password-actions mt-3">
					<button type="button" (click)="cancel()" class="btn btn-warning">
						Cancel <fa-icon class="l-icon" [icon]="faHome"></fa-icon>
					</button>

					<button [disabled]="loading || !hasValidResetContext" class="btn btn-success">
						@if (loading) {
							<span class="spinner-border spinner-border-sm mr-1"></span>
						}
						Reset Password <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
